import { render, staticRenderFns } from "./productLicenseList.vue?vue&type=template&id=476b3adf&scoped=true"
import script from "./productLicenseList.vue?vue&type=script&lang=js"
export * from "./productLicenseList.vue?vue&type=script&lang=js"
import style0 from "./productLicenseList.vue?vue&type=style&index=0&id=476b3adf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476b3adf",
  null
  
)

export default component.exports